import React from "react"
import withStyles from "@material-ui/core/styles/withStyles"
import Helmet from "react-helmet"

import MainAppChrome from "../../chrome/MainAppChrome"
import Hero from "../../../components/ui-Hero"
import HeroTitle from "../../../components/ui-HeroTitle"
import PageSection from "../../../components/ui-PageSection"
import { Container, Row, Col } from "ui-Grid"
import { Text } from "ui-Text"

import Button from "@material-ui/core/Button"

import BioSection from "../../BioSection"
import ServiceCallInstructions from "../../ServiceCallInstructions"
import StructuredData from "../../../components/StructuredData"

import { SCHEDULE_URL, ASK_URL } from "../../../lib/urls"

const styleSheet = theme => ({
  servicesContainer: {
    flex: 1,
  },

  detailsSection: {
    padding: [theme.spacing.unit * 5, 0],

    [theme.breakpoints.up("sm")]: {
      padding: [theme.spacing.unit * 10, 0],
    },
  },

  scheduleButton: {
    margin: [theme.spacing.unit, 0],
  },

  scheduleSection: {
    marginTop: theme.spacing.unit * 3,
    flexDirection: "row",
    flexWrap: "wrap",
    alignItems: "center",
  },
})

const structuredData = {
  "@context": "http://schema.org/",
  "@type": "Service",
  name: "In Home WeightCheck",
  description: "This is a 5-10 minute in home visit to weigh your little one.",
  offers: {
    "@type": "Offer",
    priceCurrency: "USD",
    price: "135.00",
    priceValidUntil: "2019-1-1",
    url: "https://jalactation.com/breastfeeding-support/in-home-consultation",
  },
}

function PostpartumConsultation({ classes }) {
  return (
    <MainAppChrome>
      <Helmet>
        <title>In Home WeightCheck </title>
        <meta
          name="description"
          content="This is a 5-10 minute in home visit to weigh your little one."
        />
      </Helmet>
      <Hero>
        <HeroTitle
          title="In Home WeightCheck"
          subTitle="This is a 5-10 minute in home visit to weigh your little one."
        />

        <Container wide flex className={classes.scheduleSection}>
          <Button
            color="primary"
            variant="outlined"
            href={SCHEDULE_URL}
            target="_blank"
            rel="noopener noreferrer"
            className={classes.scheduleButton}
          >
            Schedule In Home Help
          </Button>
          <Button color="primary" href={ASK_URL} className={classes.scheduleButton}>
            Ask a Question
          </Button>
          <StructuredData data={structuredData} />
        </Container>
      </Hero>

      <PageSection gutterTop gutterBottom>
        <Container wide>
          <Row>
            <Col md={7} xs={12}>
              <Text paragraph component="div">
                <ul>
                  <li>$15 for patients within 5 miles</li>
                  <li>$25 for patients within 10 miles</li>
                </ul>
              </Text>

              <Text>
                Or come join me at the{" "}
                <i>
                  <a
                    href="https://www.facebook.com/events/221409945101722/"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Temecula Breastfeeding Support Group
                  </a>
                </i>{" "}
                at buybuy BABY every other Tuesday for free weight checks and community with other
                moms in the area.
              </Text>
            </Col>
            <Col md={1} xs={12} />
            <Col lg={3} md={4} xs={12}>
              <ServiceCallInstructions />
            </Col>
          </Row>
        </Container>
      </PageSection>
      <BioSection />
    </MainAppChrome>
  )
}

export default withStyles(styleSheet)(PostpartumConsultation)



// WEBPACK FOOTER //
// ./src/views/pages/WeightCheck/index.js